import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { useCommonUIElements } from '../../../../hooks';
import styles from './NavigationHeader.module.scss';

declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'app-switcher': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        name: string;
        portalName: string;
        environment: string;
        entity: string;
        collapsed: boolean;
      };
    }
  }
}

export type NavigationHeaderProps = {
  title?: string;
  subtitle?: string;
};

export const NavigationHeader: FC<NavigationHeaderProps> = ({ title = '', subtitle = '' }) => {
  const { entityName, environment, currentPortalName } = useCommonUIElements();

  return (
    <div className={styles.navigationHeader}>
      <div className={styles.logoContainer}>
        <app-switcher
          name="Internal systems"
          portalName={currentPortalName}
          environment={environment}
          entity={entityName}
          collapsed={false}
        />

        <Link to="/" className={styles.title}>
          {title}
        </Link>
      </div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  );
};
